var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgVideocamera(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 256 256"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M251.77 73a8 8 0 00-8.21.39L208 97.05V72a16 16 0 00-16-16H32a16 16 0 00-16 16v112a16 16 0 0016 16h160a16 16 0 0016-16v-25l35.56 23.71A8 8 0 00248 184a8 8 0 008-8V80a8 8 0 00-4.23-7zM192 184H32V72h160v112zm48-22.95l-32-21.33v-23.44L240 95z"
  })));
}

export default SvgVideocamera;